import { WidgetConfigContext } from 'grosella/context'
import { TenantContext } from 'grosella/context/tenant-provider'
import { IntegrationType } from 'grosella/types'
import React, { h } from 'preact'
import { useContext, useMemo, useState } from 'preact/hooks'
import { Box, Button, Input, Title } from '../atoms'

import style from './search-frame.css'

interface SearchFrameProps {
    shouldShowMbl: boolean
}

export const SearchFrame: React.FunctionalComponent<SearchFrameProps> = ({
    shouldShowMbl,
}) => {
    const [searchInput, setSearchInput] = useState<string>('')
    const widgetConfig = useContext(WidgetConfigContext)
    const tenant = useContext(TenantContext)

    const handleInput = (value: string): void => {
        setSearchInput(value)
    }
    const handleClick = (event): void => {
        event.preventDefault()
        window.location.href = widgetConfig.urlPrefix
            ? `https://${tenant.domainName}/search?term=${searchInput}`
            : 'https://www.logixboard.com'
    }

    const placeholder =
        tenant?.integrationType === IntegrationType.CARGOWISE
            ? `House, ${
                  shouldShowMbl ? 'Master, Airway, ' : ''
              }Order, Container`
            : `House, ${shouldShowMbl ? 'Master, Airway, ' : ''}Container`

    return (
        <div
            className={
                style.root +
                ' ' +
                (widgetConfig.variant === 'large' ? style.large : style.compact)
            }
        >
            <Title variant={widgetConfig.variant}>Search for Shipments</Title>
            <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                width="100%"
                maxWidth="560px"
            >
                <div
                    style={{
                        width: 'calc(100% - 125px)',
                        position: 'relative',
                    }}
                >
                    <form onSubmit={handleClick}>
                        <Input
                            onInput={handleInput}
                            placeholder={placeholder}
                        />
                    </form>
                </div>
                <Button
                    disabled={searchInput === ''}
                    onClick={handleClick}
                    backgroundColor={tenant?.primaryColor}
                >
                    SEARCH
                </Button>
            </Box>
        </div>
    )
}
